import { Transition } from "components/shared/column";
import { chatTypesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Chat from "./chat";
import List from "./list";

const Chats = (props) => {
    const { match, location, history } = props;
    const rootUrl = `${match.path}/list`;
    const closeChat = () => history.push(rootUrl);
    const toChat = (id) => history.push(paths.chatsShow(id));
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => (
                        <List
                            {...props}
                            title="Чаты с водителями"
                            withoutPageSize
                            chatType={chatTypesEnum.DriverChat}
                            toChat={toChat}
                        />
                    )}
                />
                <Route
                    path={`${rootUrl}/:chatId`}
                    render={(rest) => {
                        const chatProps = { baseUrl: rootUrl, back: closeChat, chatId: rest.match.params.chatId };
                        return (
                            <Transition dir="full">
                                <Chat {...chatProps} />
                            </Transition>
                        );
                    }}
                />
            </Switch>
        </div>
    );
};

export default Chats;
